export default "__VITE_ASSET__B8da52n7__"